module.exports = __webpack_public_path__ + "static/demolition-started-5ee97cfbc5e1099328e472307324687a.png";